import { KindeProvider } from "@kinde-oss/kinde-auth-react";
import type { ReactNode } from "react";

import { DEV_BYPASS } from "@src/auth/devBypass";
import { KINDE_CLIENT_ID, KINDE_DOMAIN } from "@src/auth/kindeConfig";
import { TokenSync } from "@src/auth/TokenSync";

/**
 * Wraps the admin SPA in Kinde's auth provider.
 * Also runs TokenSync to keep the global token store populated for the
 * admin HTTP client.
 */
export const AdminAuthProvider = ({ children }: { readonly children: ReactNode }): ReactNode => {
  if (DEV_BYPASS) return <>{children}</>;
  return (
    <KindeProvider
      clientId={KINDE_CLIENT_ID}
      domain={KINDE_DOMAIN}
      redirectUri={window.location.origin}
      logoutUri={window.location.origin}
    >
      <TokenSync>{children}</TokenSync>
    </KindeProvider>
  );
};
